import React, { useState } from "react";
import axios from "axios";
import { notification, Select } from "antd";

const { Option } = Select;

const LoadForm = () => {
  const [formData, setFormData] = useState({
    pickupLocation: "",
    pickupState: "",
    pickupTime: "",
    deliverstate: "",
    deliveryLocation: "",
    weight: "",
    backhaulWeight: "",
    paying: "",
    roundTrips: "",
    slotFeeStatus: "Pending",
  });
  const [loading, setLoading] = useState(false);
  const [trunumber, setTrunumber] = useState(null);
  const [notificationTime, setNotificationTime] = useState(false);

  const usStates = [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
    "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
    "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan",
    "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
    "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio",
    "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
    "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia",
    "Wisconsin", "Wyoming"
  ];

  const generateTrackingNumber = async () => {
    let trackingNumber;
    let isUnique = false;

    while (!isUnique) {
      trackingNumber = `LE${Math.floor(100000000 + Math.random() * 900000000)}`;
      try {
        const response = await axios.get(`https://servertrucking.vercel.app/api/loads/check/${trackingNumber}`);
        if (!response.data.exists) isUnique = true;
      } catch (error) {
        console.error("Error checking tracking number:", error);
      }
    }
    return trackingNumber;
  };

  const handleChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const trackingNumber = await generateTrackingNumber();
      const formattedData = { ...formData, trackingNumber, deliveryTime: "24/7" };

      setTrunumber(trackingNumber);
      await axios.post("https://servertrucking.vercel.app/api/loads", formattedData);
      setNotificationTime(true);
      setTimeout(() => setNotificationTime(false), 10000);

      setFormData({
        pickupLocation: "",
        pickupState: "",
        pickupTime: "",
        deliverstate: "",
        deliveryLocation: "",
        weight: "",
        backhaulWeight: "",
        paying: "",
        roundTrips: "",
        slotFeeStatus: "Pending",
      });
    } catch (error) {
      notification.error({ message: "Error", description: "Failed to submit load details." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      {notificationTime && (
        <div className="alert alert-success" role="alert">
          Data Submitted Successfully with Tracking ID <strong>{trunumber}</strong>
        </div>
      )}

      <h2 className="mb-3 text-center">Load Details Form</h2>
      <form onSubmit={handleSubmit} className="card p-4 shadow">
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Pickup State</label>
            <Select
              showSearch
              className="form-control"
              value={formData.pickupState}
              onChange={(value) => handleChange("pickupState", value)}
              placeholder="Select Pickup Location"
              style={{ height: "50px" }}

            >
              {usStates.map((state) => (
                <Option key={state} value={state}>{state}</Option>
              ))}
            </Select>
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Pickup Location</label>
            <input
              type="text"
              className="form-control"
              name="pickupLocation"
              value={formData.pickupLocation}
              onChange={(e) => handleChange("pickupLocation", e.target.value)}
              required

            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Delivery Location</label>
            <input
              type="text"
              className="form-control"
              name="deliveryLocation"
              value={formData.deliveryLocation}
              onChange={(e) => handleChange("deliveryLocation", e.target.value)}
              required

            />

          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Pickup Time</label>
            <input
              type="time"
              className="form-control"
              name="pickupTime"
              value={formData.pickupTime}
              onChange={(e) => handleChange("pickupTime", e.target.value)}
              required
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Delivery State</label>
            <Select
              showSearch
              className="form-control"
              value={formData.deliverstate}
              onChange={(value) => handleChange("deliverstate", value)}
              placeholder="Select Delivery Location"
              style={{ height: "50px" }}

            >
              {usStates.map((state) => (
                <Option key={state} value={state}>{state}</Option>
              ))}
            </Select>
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Delivery Time</label>
            <input type="text" className="form-control" value="24/7" disabled />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Weight (Lbs)</label>
            <input
              type="number"
              className="form-control"
              name="weight"
              value={formData.weight}
              onChange={(e) => handleChange("weight", e.target.value)}
              required
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Backhaul Weight (Lbs)</label>
            <input
              type="number"
              className="form-control"
              name="backhaulWeight"
              value={formData.backhaulWeight}
              onChange={(e) => handleChange("backhaulWeight", e.target.value)}
              required
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Paying ($)</label>
            <input
              type="number"
              className="form-control"
              name="paying"
              value={formData.paying}
              onChange={(e) => handleChange("paying", e.target.value)}
              required
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Round Trips (Per Week)</label>
            <input
              type="number"
              className="form-control"
              name="roundTrips"
              value={formData.roundTrips}
              onChange={(e) => handleChange("roundTrips", e.target.value)}
              required
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Slot Fee Status</label>
            <Select
              className="form-control"
              value={formData.slotFeeStatus}
              onChange={(value) => handleChange("slotFeeStatus", value)}
              style={{ height: "50px" }}
            >
              <Option value="Pending">Pending</Option>
              <Option value="Shipped">Shipped</Option>
            </Select>
          </div>
        </div>

        <button type="submit" className="default-btn text-center w-100" disabled={loading}>
          {loading ? "Submitting..." : "Submit Load"}
        </button>
      </form>
    </div>
  );
};

export default LoadForm;
